<div class="label">
  <span>Payments are encrypted</span>
  <img src="assets/icons/icon-lock.svg" />
</div>